import React from "react";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import TextBox from './Components/TextBox.jsx';
import TextMulti from './Components/TextMulti.jsx';
import CheckBox from './Components/CheckBox.jsx';
import { Constants, Routes } from './../Core/Constants';
import { Storage } from './../Core/Storage';

import ErrorFocus from './Components/InvalidScrolling.jsx'



const CheckoutUserForm = ({ initValues, onSubmit, saveContactTo, isLoading, loadingText }) => {
	let T = window.Texts.contactForm;
	let isAnonymous = !Storage.instance().isAuthorized();


	let invoiceSchema = Yup.object({

		firstName: Yup.string()
			.required(T.required),

		lastName: Yup.string()
			.required(T.required),
		address: Yup.string()
			.required(T.required),
		city: Yup.string()
			.required(T.required),
		zip: Yup.string()
			.required(T.required)
			.min(2, T.minTwoDigits)
			.max(16, T.maxLen.replace('%len%', 16)),
		email: Yup.string()
			.email(T.wrongEmail)
			.required(T.required),
		phone: Yup.string()
			.required(T.required),

		companyName: Yup.string()
			.when('isCompany', {
				is: (isCompany) => isCompany == true,
				then: Yup.string()
					.required(T.required),
				otherwise:
					Yup.string().nullable()
			}),
		isCompany: Yup.boolean(),
		companyIdNumber: Yup.string()
			.when('isCompany', {
				is: (isCompany) => isCompany == true,
				then: Yup.string()
					.required(T.required),
				otherwise:
					Yup.string().nullable()
			}),
		companyTaxNumber: Yup.string().nullable()
	});

	let invoiceFormEnabled = isAnonymous || (!isAnonymous || invoiceSchema.isValidSync(initValues.invoiceContact));

	let deliverySchema = Yup.object({
		firstName: Yup.string()
			.when('isDeliveryContact', {
				is: (isDeliveryContact) => isDeliveryContact == true,
				then: Yup.string()
					.required(T.required),
				otherwise:
					Yup.string().nullable()
			}),
		lastName: Yup.string()
			.when('isDeliveryContact', {
				is: (isDeliveryContact) => isDeliveryContact == true,
				then: Yup.string()
					.required(T.required),
				otherwise:
					Yup.string().nullable()
			}),
		address: Yup.string()
			.when('isDeliveryContact', {
				is: (isDeliveryContact) => isDeliveryContact == true,
				then: Yup.string()
					.required(T.required),
				otherwise:
					Yup.string().nullable()
			}),
		city: Yup.string()
			.when('isDeliveryContact', {
				is: (isDeliveryContact) => isDeliveryContact == true,
				then: Yup.string()
					.required(T.required),
				otherwise:
					Yup.string().nullable()
			}),
		zip: Yup.string()
			.when('isDeliveryContact', {
				is: (isDeliveryContact) => isDeliveryContact == true,
				then: Yup.string()
					.required(T.required),
				otherwise:
					Yup.string().nullable()
			}),
	});

	let validationSchema = Yup.object({
		invoiceContact: invoiceSchema,
		deliveryContact: deliverySchema,
		remarks: Yup.string()
			.max(250, T.maxLen.replace('%len%', 250))
	});
	return (
		<Formik initialValues={initValues} validationSchema={validationSchema} onSubmit={(values, { setSubmitting }) => onSubmit(values, setSubmitting, saveContactTo)} >
			{props => (
				<Form autoComplete="off">
				
					<div>
						<div className="box form-box invoice-address">
							<h2>{T.invoiceData}</h2>
							
							<>
								{Storage.instance().isAuthorized() ? null :
									<p style={{ marginBottom: '20px' }}>{T.alreadyAccount + ' '}
										<a href={Routes.Login}>{T.login}</a> {T.fillData}</p>}

									<div className="prow form">
									<div className="pcol form-group input-5">
										<TextBox type="text" name="invoiceContact.firstName" required={true} label={T.name} readOnly={!invoiceFormEnabled} placeholder={T.name + ':'} autoComplete="given-name" />
										</div>
										<div className="pcol form-group input-5">
										<TextBox type="text" name="invoiceContact.lastName" required={true} readOnly={!invoiceFormEnabled} label={T.surname} placeholder={T.surname + ':'} autoComplete="family-name"/>
										</div>
									<div className="pcol form-group input-10">
										<TextBox type="text" name="invoiceContact.address" required={true} readOnly={!invoiceFormEnabled} label={T.address} placeholder={T.address + ':'} autoComplete="street-address" />
										</div>
										
									<div className="pcol form-group input-5">
										<TextBox type="text" name="invoiceContact.city" required={true} readOnly={!invoiceFormEnabled} label={T.city} placeholder={T.city + ':'} autoComplete="address-level2" />
										</div>
									<div className="pcol form-group input-5">
										<TextBox type="text" name="invoiceContact.zip" required={true} readOnly={!invoiceFormEnabled} label={T.zip} placeholder={T.zip + ':'} autoComplete="postal-code" />
										</div>
										<div className="pcol form-group input-10">
											<label>{T.country + ':'}</label>
											<p style={{ fontSize: '16px', fontWeight: 'bold' }}>{T.selectCountry}</p>
										</div>
									</div>


								<h2>{T.Contact}</h2>
									<div className="prow form">
										<div className="pcol form-group input-10">
										<TextBox type="text" name="invoiceContact.email" required={true} label={T.email} placeholder={T.email + ':'} autoComplete="email"/>
										</div>
										<div className="pcol form-group input-10">
										<TextBox type="text" name="invoiceContact.phone" required={true} label={T.phone} placeholder={T.phone + ':'} autoComplete="tel" />
										</div>
									</div>



								<div className="check-box" style={{ paddingBottom: '10px' }} className="invoiceContact-iscompanycheck">
									<CheckBox className="agree_label" name="invoiceContact.isCompany" >
											<>{T.showCompanyData}</>
										</CheckBox>
									</div>
								</>
							<div className="prow form IsFirmAddress" style={{ display: (props.values.invoiceContact.isCompany) ? 'block' : 'none' }}>
								<div className="pcol form-group input-10">
									<TextBox type="text" name="invoiceContact.companyName" required={true} readOnly={!invoiceFormEnabled} label={T.firm} placeholder={T.firm + ':'} autoComplete="organization-title" />
								</div>
								<div className="pcol form-group input-5">
									<TextBox type="text" name="invoiceContact.companyIdNumber" required={true} readOnly={!invoiceFormEnabled} label={T.ic} placeholder={T.ic + ':'} />
								</div>
								<div className="pcol form-group input-5">
									<TextBox type="text" name="invoiceContact.companyTaxNumber" required={false} readOnly={!invoiceFormEnabled} label={T.dic} placeholder={T.dic + ':'} />
								</div>
							</div>
							<div className="check-box">
								<CheckBox className="agree_label" name="deliveryContact.isDeliveryContact">
									<>{T.insertOtherAddress}</>
								</CheckBox>
							</div>
						</div>

						<div className="box form-box other-delivery" style={{ display: (props.values.deliveryContact.isDeliveryContact) ? 'block' : 'none' }}>
							<h2>{T.otherAddress}</h2>
							<div className="prow form">
								<div className="pcol form-group input-5">
									<TextBox type="text" name="deliveryContact.firstName" required={true} label={T.name} placeholder={T.name + ':'} />
								</div>
								<div className="pcol form-group input-5">
									<TextBox type="text" name="deliveryContact.lastName" required={true} label={T.surname} placeholder={T.surname + ':'} />
								</div>
								<div className="pcol form-group input-10">
									<TextBox type="text" name="deliveryContact.address" required={true} readOnly={!invoiceFormEnabled} label={T.address} placeholder={T.address + ':'} />
								</div>
								<div className="pcol form-group input-5">
									<TextBox type="text" name="deliveryContact.city" required={true} label={T.city} placeholder={T.city + ':'} />
								</div>
								<div className="pcol form-group input-5">
									<TextBox type="text" name="deliveryContact.zip" required={true} label={T.zip} placeholder={T.zip + ':'} />
								</div>
								<div className="pcol form-group input-10">
									<label>{T.country}: </label>
									<p style={{ fontSize: '16px', fontWeight: 'bold' }}>{T.selectCountry}</p>
								</div>
							</div>
						</div>


						<div className="box form-box comment-box">
							<h2>{T.notes}</h2>
							<div className="form-group">
								<TextMulti name="remarks" rows="4" maxlength="250" style={{ width: '100%', height: '124px', lineHeight: "20px" }} maxLen label={T.note + ':'} />
							</div>
							<button className="btn btn50 iconed icon-continue btn-finish" type="submit" style={isLoading ? {} : { height: '70px'}}>
								<span>
									
									{(isLoading) ? loadingText :
										<>
											<section style={{ lineHeight: '26px', fontSize: '20px', textTransform: 'uppercase'}}>{T.finish}</section>
											<section style={{ lineHeight: '12px', fontSize: '10px' }}>{T.finishNotes}</section>
										</>
										}
								</span></button>
							<p>&nbsp;</p>
							<p className="gdpr__part">{T.clickFinish}
								<a target="_blank" href={Routes.TradeTerms}>{T.withTradeTerms}</a>. <br /> {T.acknowledge} <a target="_blank" href={Routes.Gdpr}>{T.proccessPersonalData}</a>.
							</p>
						</div>
					</div>
					<ErrorFocus />
				</Form>
			)}
		</Formik>);
}

export default CheckoutUserForm;
